import React from "react";

const Java_Intro = () => {
  return (
    <div>
      <h1>Java Intro</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Intro in Java.</p>
    </div>
  );
};

export default Java_Intro;
